<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1100" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" hide-details />
        </div>

        <SectionLayout :settings="fields.settings" :container-page="fields.containerPage" />

        <div class="mb-5">
          <label class="label-input">Title & Description</label>
          <div class="group-item">
            <ckeditor :editor="editor" v-model="fields.content" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-5">
          <label class="label-input">Banner Image</label>
          <div class="group-item">
            <label>Desktop Image</label>
            <UploadImage
              :image="{ imageSrc: fields.imageDesktop }"
              :height="`200`"
              :typeUpload="'image'"
              @callback="obj => (fields.imageDesktop = obj.imageSrc)"
              @callbackDelete="fields.imageDesktop = ''"
            />
            <v-checkbox v-model="fields.useBannerMobile" label="Use mobile image" hide-details class="mt-4 mb-2" />
            <template v-if="fields.useBannerMobile">
              <label>Mobile Image</label>
              <UploadImage
                :image="{ imageSrc: fields.imageMobile }"
                :height="`200`"
                :typeUpload="'image'"
                @callback="obj => (fields.imageMobile = obj.imageSrc)"
                @callbackDelete="fields.imageMobile = ''"
              />
            </template>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { cloneDeep } from 'lodash';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '../common/html/update';
import UploadImage from '../common/form/upload-file/upload-image.vue';
import SectionLayout from '../common/ui-modules/section-layout/editor.vue';

const getDefaultFields = () => ({
  title: 'Cefloreco Banner 1 Section',
  settings: {
    paddingTop: true,
    paddingBottom: true,
    backgroundColor: '#FFFFFF',
    textColor: '#000000',
    overlayColor: '#000000',
    overlayOpacity: 0,
    showOverlay: false,
    backgroundImage: '',
    useCustomWidth: true,
    customWidth: 1204,
  },
  containerPage: {
    enableStyle: false,
    background: '#FFFFFF',
  },
  content:
    '<p>Digital Product Studio</p><h2>Creativity brought to life</h2><p>We turn ideas into digital products, stories and experiences used worldwide.</p>',
  useBannerMobile: true,
  imageDesktop: 'https://cefloreco.com/images/bg-creativity.webp',
  imageMobile: 'https://cefloreco.com/images/bg-creativity-mb.webp',
});

export default {
  name: 'CeflorecoBanner1SectionEditor',
  components: { UploadImage, SectionLayout },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: getDefaultFields(),
    };
  },
  mounted() {
    const def = getDefaultFields();
    const extract = cloneDeep(this.sectionEditor.sectionExtract || {});

    this.fields = {
      ...def,
      ...extract,
      settings: { ...def.settings, ...(extract.settings || {}) },
      containerPage: { ...def.containerPage, ...(extract.containerPage || {}) },
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCeflorecoBanner1(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.group-item {
  border: 1px solid #0000000f;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
.ck-editor__editable_inline,
.ck-editor__editable {
  min-height: 140px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
